import React, {useEffect, useState} from 'react';
import { Container, Row, Col } from 'reactstrap';
import { PodiumPosOne, PodiumPosSecond, PodiumPosThird } from '../svgs';
import { useIntl } from 'react-intl';
import QuizControls from "./quiz-controls";
import PodiumControls from "./podim-controls";
import {EslidesEvent, Presentation} from "../../types/presentation";
import axios from "axios";
import {useLocation} from "react-router-dom";
import {InLinePreLoader} from "../preloader";



const QuizAnswerPodium:React.FC<{ locale: string; setLocale: any; presentation: Presentation; event: EslidesEvent;questionId: String; }> = ({ locale, setLocale, presentation,event,questionId }) => {
  const [users, setUsers] = useState<any[]>([]);
  const [final, setFinal] = useState(false);
  const [questionIndex, setQuestionIndex] = useState(0);
    const [dataLoading, setDataLoading] = useState(true);

  const intl = useIntl();
    const location = useLocation();
    const stateData = location.state;

    useEffect(() => {
        var data = location.state;
        // @ts-ignore
        setQuestionIndex(data?.index??0);
        // @ts-ignore
        console.log("PAGE INDEX PODIUM",data?.index,questionIndex)
    }, [location.state]);


  // getting the quiz question result
  useEffect(() => {
     console.log("QA ID")
    axios({
      method: "POST",
      //url: 'http://localhost:4000/stage/api/quiz/get-code',
      url: `${process.env.REACT_APP_API_ENDPOINT}/api/quiz/get-question-result`,
      data: {
        _id: questionId,
      },
    }).then((res) => {
        setDataLoading(false)

       console.log("QA ID RESPONSE",res.data)
      try {
        if (res.data.statusCode === 200) {
          setUsers(res.data.data);
           console.log("QA ID RESPONSE",res.data.data)
        }
      } catch (e) {
         console.log("QA ID FAIL",e)
      }

    });
    // setting the quiz current_questions_index
    var countString =  localStorage.getItem(`current_questions_index`);
    // @ts-ignore
    var data = countString.split('/');
     console.log("DATA MAP",data)
    // check current question is the final question in order to show final podium
    if(data[0]===data[1]){
      setFinal(true)
       console.log("DATA MAP","Same")
    }


  },[questionId])

  return (
    <div className="podium-container quiz-live-screen-container">
      <div className="podium-main">
        <Container>
          <Row>
            <Col>
              {/*show result when the user list have data*/}
              {users.length>0 && (<div className="podium-results-container m-t-60">
                <h5 className="text-primary">PODIUM question {localStorage.getItem(`current_questions_index`)}</h5>
                <p className="q">{localStorage.getItem(`current_questions`)}</p>

                <div className="d-block d-md-none">
                  <div className="your-position">
                    <span>{intl.formatMessage({id: 'sidebar.you.are.the'})} <strong>18<sup>th</sup></strong>,</span>
                    <span className="points">{intl.formatMessage({id: 'with'})} <strong>220 {intl.formatMessage({id: 'points'})}</strong></span>
                  </div>
                </div>

                <div className="d-block d-md-none">
                  <div className="mobile-stage-container">
                    {users.length>1 &&  <div className="score-details first">
                      <span className="stand"></span>
                      <span className="score">
                        {users[1].name.length >20 ? users[1].name.split(' ')[0] :users[1].name}<span>+{users[1].points}</span>
                        </span>
                    </div> }
                    {users.length>0 && <div className="score-details second">
                      <span className="stand"></span>
                      <span className="score">
                       {users[0].name.length >20 ? users[0].name.split(' ')[0] :users[0].name}<span>+{users[0].points}</span>
                        </span>
                    </div>}
                    {users.length>2 && <div className="score-details third">
                      <span className="stand"></span>
                      <span className="score">
                        {users[2].name.length >20 ? users[2].name.split(' ')[0] :users[2].name}<span>+{users[2].points}</span>
                        </span>
                    </div>}
                  </div>
                </div>

                <div className="stage m-t-20 d-none d-md-flex ">
                  <div className="stage-components">
                    {users.length>1 &&  <div className="pos second">
                      <div className="score-container">
                          <span className="score">
                          {users[1].name.length >20 ? users[1].name.split(' ')[0] :users[1].name}<span>+{users[1].points}</span>
                          </span>
                        <PodiumPosSecond />
                      </div>
                      <span className="stand"></span>
                    </div> }
                    {users.length>0 && <div className="pos first">
                      <div className="score-container">
                        <PodiumPosOne />
                        <span className="score">
                          {users[0].name.length >20 ? users[0].name.split(' ')[0] :users[0].name}<span>+{users[0].points}</span>
                          </span>
                      </div>
                      <span className="stand"></span>
                    </div>}
                    {users.length>2 && <div className="pos third">
                      <div className="score-container">
                        <PodiumPosThird />
                        <span className="score">
                       {users[2].name.length >20 ? users[2].name.split(' ')[0] :users[2].name}<span>+{users[2].points}</span>
                        </span>
                      </div>
                      <span className="stand"></span>
                    </div>}
                  </div>
                </div>
              </div>)}

                <Row>
                    <Col className="mx-auto" md={10}>
                        <div className="remaining-results m-t-40">
                            {users.length>0 && <ul>
                                {users.slice(3,30).map((value, index) => {
                                    return (
                                        <li key={index}><span>{index+1}/{value.name}<span>+ {value.points}</span></span></li>
                                    )
                                })}
                            </ul>}
                            {dataLoading  &&   <div className='container'>
                                <div className='row'>
                                    <Col>
                                        <div className="quiz-live-answers-container" style={{justifyContent:'center',display:'flex'}}>
                                            <InLinePreLoader />
                                        </div>
                                    </Col>
                                    <div>
                                    </div>
                                </div>
                            </div>}

                            {(users.length === 0 && !dataLoading)  &&  <span style={{justifyContent:'center',width:"inherit",display:'flex'}}>No Answers Found</span>}
                        </div>
                    </Col>

                </Row>
            </Col>
          </Row>
        </Container>
      </div>
      <PodiumControls quizQuestionIndex={questionIndex} answerId="asd" presentationId={presentation._id}  usersLength={2} podium={false} answersLength={10} onBack={true} noNext={final}  />

    </div>
  )
}

export default QuizAnswerPodium;
